import React from 'react';
import FilterScreeningAutocomplete from './autocompletes/FilterScreeningAutocomplete';
import LensScreeningAutocomplete from './autocompletes/LensScreeningAutoComplete';

interface IFilterColumn {
  title: string;
  icon: any;
  options: any;
  selections: any;
  setSelections: any;
  setSubmit: any;
  submit: any;
  state: any;
  type: any;
  countOpts?: string[];
  agOpts?: string[];
  loading: boolean;
  location: string;
}

const FilterColumn: React.FC<IFilterColumn> = ({ type, state, icon, title, options, selections, setSelections, setSubmit, submit, countOpts, agOpts, loading, location }) => {
  const handleChange = (e: string[]) => {
    const arr: any[] = [ ...e ];
    setSelections({
      ...state,
      [`${type}`]: arr
    });
    setSubmit({
      trigger: !submit.trigger,
      reason: title,
      location: location
    });
  };

  return (
    <div className='filter-column-container'>
      <div className='filter-column-header'>
        {icon}
        <div className='filter-column-header-title'>
          {title}
        </div>
      </div>
      <div className='filter-column-options-container'>
        {!loading ? (
          options.length === 0 ?
            (
              <div className='filter-column-options-no-opts'>
                <p>Make a Selection from the Previous List</p>
              </div>
            ) : (
              // title === 'Lens' ? (
              //   <LensScreeningAutocomplete
              //     options={options}
              //     placeholder='Search'
              //     onChange={handleChange}
              //     toClear={false}
              //     selections={selections}
              //   />
              // ) :
          // (
              <FilterScreeningAutocomplete
                options={options}
                placeholder='Search'
                onChange={handleChange}
                toClear={false}
                selections={selections}
                countOpts={countOpts}
                agOpts={agOpts}
                disable={(title === 'Agency' && state.countries.length !== 0) || (title === 'Listing Country' && state.lenses.length !== 0) || (title === 'Country Regulator' && state.comLenses.length !== 0)}
              />
          // )
            )
        ) : (
          <div className='spinner-spacer-top'>
            <div className='loader'>Loading...</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterColumn;
